import { z } from 'zod';

import { TypeSavedSection } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const SavedSectionEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    label: z.string(),
    category: z.string(),
    node: z.any().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateSavedSectionEntry(data: TypeSavedSection) {
  return SavedSectionEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateSavedSectionEntries(data: TypeSavedSection[]) {
  return z.array(SavedSectionEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterSavedSectionEntries(data: TypeSavedSection[]) {
  if (!data) return [];

  return data.reduce((acc: TypeSavedSection[], entry) => {
    const validationResult = validateSavedSectionEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeSavedSection);
    } else {
      console.warn(
        `Validation failed for saved section entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
